import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '../Core';
import {
  IListOfValuesServiceRequestType,
  ListType,
} from '../Types/ListOfValues.types';

export const API_DOMAIN: EndPointsNames = 'ApiGwBr';
export const ENDPOINT_API_PATH = '/act/listofvalues/values';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
export const URL_POSTMAN = ``;

export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '',
    bussinessErrorVariant: 'invalidToken',
    message: 'Ocorreu um erro ao gerar token',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

export type ListOfValuesApiRequest = {
  language: 'pt_br' | 'en_us' | 'es_es';
  type: ListType;
  sortByField?: string[];
  sortOrder?: ('ASC' | 'DESC')[];
  page?: number;
  quantity?: number;
};

export type OrderField = {
  field: string;
  order: 'ASC' | 'DESC';
};

export type Pagination = {
  page: number;
  quantity: number;
  total: number;
};

export type ValueByType = {
  name: string;
  value: string;
  description?: string;
};

export type ListOfValuesApiResponse = {
  valueByTypeList: ValueByType[];
  metaInformation?: {
    orderField?: OrderField[];
    pagination?: Pagination;
  };
};

const callGet = async (
  params: IListOfValuesServiceRequestType,
): Promise<IFinalResponse> => {
  const queryParams: ListOfValuesApiRequest = {
    language: params.language,
    type: params.listType,
  };

  if (params.page) {
    queryParams.page = params.page;
  }

  if (params.pageSize) {
    queryParams.quantity = params.pageSize;
  }

  if (params.sortByField) {
    queryParams.sortByField = params.sortByField;
  }

  if (params.sortOrder) {
    queryParams.sortOrder = params.sortOrder;
  }

  const init: InitApiType = {
    params: queryParams,
    headers: {},
  };

  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };
export default { call, definitions };
